<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="'Edit Division :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light"><i class="fa fa-cogs"></i> Admin</li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link to="/admin/divisions">
                            Divisions
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active"><i class="fa fa-edit"></i> Edit</li>
                </ol>
            </h4>

            <div class="row mb-4">
                <div class="col-xl-6 col-lg-8 col-12">
                    <div class="card">
                        <div class="card-body">
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.DivisionName }" class="row">
                                <label class="col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right">
                                    Division Name: <i class="fa fa-asterisk text-danger"></i>
                                </label>
                                <div class="col-lg-6 col-md-9 col-sm-8">
                                    <input type="text" name="DivisionName" v-model="division.DivisionName" class="form-control" placeholder="Enter Name (Required)" />
                                    <span v-if="errors.DivisionName" class="text-danger">
                                        <span v-for="error in errors.DivisionName">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.division_code }" class="row">
                                <label class="col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right">Division Code:</label>
                                <div class="col-lg-6 col-md-9 col-sm-8">
                                    <input type="text" name="division_code" v-model="division.division_code" class="form-control" placeholder="Enter Code (Optional)" />
                                    <span v-if="errors.division_code" class="text-danger">
                                        <span v-for="error in errors.division_code">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div v-bind:class="{ 'form-group': true}" class="row">
                                <label class="col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right">Is Active:</label>
                                <div class="col-lg-6 col-md-9 col-sm-8">
                                    <b-form-checkbox v-model="division.IsActive" :value="1" :unchecked-value="0" plain/>
                                </div>
                            </div>

                            <div class="row form-group">
                                <label class="col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right">
                                    PDF Logo: <i class="fa fa-question-circle" title="If set, this logo will override the Account PDF Logo on Inspection and Incident PDF Reports"></i>
                                </label>
                                <div class="col-lg-6 col-md-9 col-sm-8">
                                    <b-form-file v-model="pdf_logo" accept="image/*" placeholder="Upload Division PDF Logo" />

                                    <template v-if="show_pdf_logo && division.pdf_logo">
                                        <div class="mt-3 py-2 px-2 mb-3" style="border: 1px dashed #ececec; overflow-x: auto; overflow-y: auto">
                                            <img v-bind:src="division.pdf_logo" />
                                        </div>

                                        <a href="javascript:void(0)" v-on:click="removeDivisionPDF()" class="text-danger" :disabled="saving">
                                            <span v-if="!saving">
                                                <i class="fa fa-trash text-danger"></i> Remove Division PDF Logo
                                            </span>
                                            <span v-else>
                                                <i class="fa fa-spin fa-spinner"></i> Removing
                                            </span>
                                        </a>
                                    </template>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <button type="button" class="btn btn-sm btn-success" v-on:click="saveDivision(this)" :disabled="saving">
                Save Division
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                saving: false,
                show_pdf_logo: false,
                pdf_logo: null,
                division_id: this.$route.params.id,
                division: {},
                errors: {},
            }
        },

        methods: {

            getDivision() {
                //Get the data
                this.$http
                    .get('admin/divisions-edit' + (this.division_id ? '/' + this.division_id : ''))
                    .then(response => {
                        //Set all the data
                        this.division = response.data;

                        //Check logo
                        if(this.division.pdf_logo)
                        {
                            //Set the helper
                            this.show_pdf_logo = true;
                        }

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            saveDivision() {
                //Show loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Setup
                var files = {};

                //Check PDF Logo
                if(this.pdf_logo)
                {
                    files['pdf_logo'] = this.pdf_logo;
                }

                //Send it
                this.$http
                    .postWithFiles('admin/divisions-edit' + (this.division_id ? '/' + this.division_id : ''), this.division, files)
                    .then(response => {
                        //Alert the user?
                        this.$toastr.success('Division Saved');

                        //Return to main list?
                        this.$router.push('/admin/divisions');
                    })
                    .catch(error => {
                        //Check for error
                        if(error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data
                        }
                    })
                    .then(response => {
                        //SHow loading
                        this.saving = false;
                    });
            },

            removeDivisionPDF(){
                //Show loading
                this.saving = true;

                //Send it
                this.$http
                    .post('admin/divisions-delete-pdf-logo/' + this.division.DivisionId)
                    .then(response => {
                        //Alert the user?
                        this.$toastr.success('Division PDF Removed');

                        //Reset
                        this.division.pdf_logo = null;
                        this.pdf_logo = null;
                        this.show_pdf_logo = false;
                    })
                    .catch(error => {
                        //Check for error
                        if(error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data;
                        }
                    })
                    .then(response => {
                        //SHow loading
                        this.saving = false;
                    });
            },
        },

        mounted() {
            //Get the incidents
            this.getDivision();
        }
    }
</script>
